import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function ContextTable({contexts}) {
    return (
        <React.Fragment>
            <Table size="small">
                <TableBody>
                    {contexts.map(context => (
                        <TableRow key={context.id}>
                            <TableCell>{context.name}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    );
}
